module.exports = __webpack_public_path__ + "img/mahogany-swatch.e9d8375a.png";